import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageState from '../components/page/PageState';
import { useApp } from '../context/AppContext';
import LibraryCuratorConsole from '../components/libraryTemplates/LibraryCuratorConsole';
import LibraryTemplateLookup from '../components/libraryTemplates/LibraryTemplateLookup';
import { canCurateLibrary, canLookUpLibraryTemplate } from '../utils/libraryTemplateModel';

/**
 * Template Library (Sheet-2 row 2) — ISO/IEC 27001:2022 Cl. 7.5.3 / A.5.37;
 * .claude/design/library-curator.md.
 *
 * Two persona shapes (each gated here AND by the API):
 *   platform admin         : the curator console (fetch / AI-draft / edit / review / publish / retire)
 *   Lead Advisor / Advisor : inside a project, look up the current published template for a control
 *   anyone else            : nothing — no persona-visible affordance
 *
 * The curator console is global (the library is a platform master, not tenant data), so it does
 * not need an active project; the consumption lookup is project-scoped and does.
 */
const LibraryTemplatesPage = () => {
    const { user, activeProject } = useApp();
    const role = user?.role;

    if (canCurateLibrary(role)) {
        return (
            <PageShell>
                <PageHeader title="Template Library" subtitle="Curate the library of templates that projects draw Stage-7 documents from" />
                <LibraryCuratorConsole />
            </PageShell>
        );
    }
    if (canLookUpLibraryTemplate(role)) {
        if (!activeProject) return <PageState status="empty" message="Open a project to look up its library templates." />;
        return (
            <PageShell>
                <PageHeader title="Template Library" subtitle="Published control templates for Stage-7 drafting" />
                <LibraryTemplateLookup projectId={activeProject.id} projectName={activeProject.companyName || activeProject.name} />
            </PageShell>
        );
    }
    return <PageState status="empty" message="The template library is not available for your role." />;
};

export default LibraryTemplatesPage;
